import React, { useMemo, useState } from 'react';
import { isEmpty } from 'ramda';
import { useParams } from 'react-router-dom';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

// tools
import getDateFromISOstring from '../../../../../../helpers/getDateFromISOstring';

// store
import { storeSet, useStoreValue } from '../../../../../../store';

// components
import VideoIcon from '../../../../../../icons/VideoIcon';
import TripleDotsIcon from '../../../../../../icons/TripleDotsIcon';
import PlusIcon from '../../../../../../icons/PlusIcon';
import ModalUploadVideo from '../../../../../../components/ModalUploadVideo';
import ButtonIconContextMenu from '../../../../../../components/ButtonWrapper/components/ButtonIconContextMenu';
import formatDuration from '../../../../../../helpers/formatDuration';
import ProjectService from '../../../../../../service/project-service';

// hooks
import useSelection from '../../../../../../hooks/useSelection';
import { SELECTION_KINDS } from '../../../../../../helpers/selection';

const VideoList = () => {
    const { projectId } = useParams();
    const myStudioLeftPanel = useStoreValue('myStudioLeftPanel');
    const projectVideos = useStoreValue('projectVideos');
    const [showUploadModal, setShowUploadModal] = useState(false);

    const orderedIds = useMemo(() => (projectVideos || []).map(item => item.id), [projectVideos]);
    const { isSelected, select } = useSelection(SELECTION_KINDS.VIDEO, orderedIds);

    const handleVideoDelete = (id) => {
        storeSet('deleteVideoItem', projectId, id)
    }

    const [syncing, setSyncing] = useState({});
    const handleSmartSync = async (id) => {
        setSyncing(prev => ({ ...prev, [id]: true }));
        try {
            await ProjectService.analyzeSyncPointsAsync(projectId, id);
        } catch (e) { /* gestito dal network-service */ }
        // i punti compaiono al prossimo fetch: ricarico dopo qualche secondo
        setTimeout(() => { storeSet('refetchVideos', projectId); setSyncing(prev => ({ ...prev, [id]: false })); }, 6000);
    };

    return (
        myStudioLeftPanel === 'video'
            ? <>
                <OverlayScrollbarsComponent element="div" options={{ scrollbars: { autoHide: 'never' } }} defer>
                <ul className="timelineEditorAuxControls__listOfVideos">
                    {projectVideos && !isEmpty(projectVideos)
                        ? projectVideos.map(item => <li key={`video_${item.id}`}
                            className={`auxListItem${isSelected(item.id) ? ' auxListItem--selected' : ''}`}
                            aria-selected={isSelected(item.id)}
                            onClick={(e) => {
                                if (e.target.closest('button, a, input, dialog')) return;
                                select(item.id, e);
                            }}>
                            {item.thumbnailUrl
                                ? <picture>
                                    <img src={item.thumbnailUrl} alt="video thumb"/>
                                </picture>
                                : <div className="videoPlaceholder">
                                    <VideoIcon/>
                                </div>}
                            <div className="title">
                                <h3>{item.name}</h3>
                                <span>{formatDuration(item.duration)}</span>
                                {item.syncPoints && item.syncPoints.count > 0 && (
                                    <span className="videoSyncBadge" style={{ fontSize: '10px', color: '#4dc9fc' }}>{item.syncPoints.count} punti di sync</span>
                                )}
                            </div>
                            <div className="meta lastGroup">
                        <span>{getDateFromISOstring(item.date, {
                            day: '2-digit',
                            month: 'short'
                        })}</span>
                                <ButtonIconContextMenu menuItems={[
                                    { label: syncing[item.id] ? 'Smart Sync in corso…' : 'Smart Sync (rileva tagli)', onClick: () => handleSmartSync(item.id) },
                                    { label: 'Cancella', onClick: () => handleVideoDelete(item.id) },
                                ]}>
                                    <TripleDotsIcon/>
                                </ButtonIconContextMenu>
                            </div>
                        </li>) : null}
                </ul>
                </OverlayScrollbarsComponent>
                <button className="timelineEditorAuxControls__addNew" onClick={() => setShowUploadModal(true)}>
                    <PlusIcon/>
                </button>
                {showUploadModal && (
                    <ModalUploadVideo
                        projectId={projectId}
                        onClose={() => setShowUploadModal(false)}
                    />
                )}
            </> : null
    );
};

export default VideoList;
